export default "__VITE_ASSET__CNgTipBJ__"